type TokenInformationT = {
  token?: string,
  tokenExpiresAt?: number
}

type AuthChangeCallbackT = (isAuthenticated: boolean, tokenInformation: TokenInformationT) => void

let authCbs: AuthChangeCallbackT[] = [];

export function onAuthChange(cb: AuthChangeCallbackT) {
  authCbs.push(cb);
  return () => {
    authCbs = authCbs.filter((currentCb) => currentCb !== cb);
  };
}

export function __fireOnAuth(isAuthenticated: boolean, tokenInformation: TokenInformationT) {
  return authCbs.forEach((cb) => cb(isAuthenticated, tokenInformation));
}
